import { useBinanceOrderBook } from "./BinanceOrderBooksocket";
import { useBybitOrderBook } from "./BybitOrderBookSocket";
import { useOwnOrderBook } from "./OwnSocket";

export function useExchangeOrderBook(symbol, priceType) {
    const binanceBook = useBinanceOrderBook(priceType === "Binance" ? symbol : null);
    const bybitBook = useBybitOrderBook(priceType === "Bybit" ? symbol : null);
    const ownBook = useOwnOrderBook(priceType === "Own" ? symbol : null);

    try {
        switch (priceType) {
            case "Binance":
                return binanceBook;
            case "Bybit":
                return bybitBook;
            case "Own":
                return ownBook;
            default:
                return { bids: [], asks: [], symbol };
        }
    } catch (error) {
        console.error(`Error on useExchangeOrderBook: ${error}`);
        return { bids: [], asks: [], symbol };
    }
}